<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper">
        <div class="tabs">
            <div class="tab" (click)="tab = 0; setCardAndJobID(0, 0)" [ngClass]="{'active': tab == 0}">
                {{"All" | translate}}
            </div>
            <div class="tab" (click)="tab = 1; setCardAndJobID(task_id, 0)" [ngClass]="{'active': tab == 1}">
                {{ "Card Chats" | translate }}
            </div>
            <div class="tab" (click)="tab = 2; setCardAndJobID(task_id, task_operation_id)" [ngClass]="{'active': tab == 2}">
                {{ "Job chats" | translate }}
            </div>
        </div>
        <div class="forward_body">
            <div class="body_nav" *ngIf="tab == 1">
                <div class="jobs">
                    <div class="filter_exp_search start_search">
                        <mat-form-field appearance="legacy" class="filter_form search full_width_form">
                            <mat-icon class="icon_16" matPrefix>search</mat-icon>
                            <input class="search_inp" [formControl]="cardJobControl" matInput #search>
                            <!-- <mat-icon style="cursor: pointer;" (click)="openFilter(typeFilter); $event.preventDefault(); $event.stopPropagation();" matSuffix>tune</mat-icon> -->
                        </mat-form-field>
                    </div>
                    <div class="jobs_wrp" [appDeviceClass]="'custom-scroll custom-scroll-t'">
                        <ng-container *ngFor="let job of cardJobs$ | async">
                            <div class="job_item" (click)="setCardAndJobID(job.task_id, job.id)" [ngClass]="{'active': filter.value.task_operation_id == job.id}">
                                <div class="item_header">
                                    <div class="primary_tag">
                                        <div class="text_one_line">{{ job?.operation?.name }}</div>
                                        <span *ngIf="getPrimaryTag(job)" class="text_one_line val">{{getPrimaryTag(job)?.parameterValue?.value}}</span>
                                    </div>
                                    <div class="id">{{ job?.id }}</div>
                                </div>
                                <div class="name text_one_line">{{ job?.name }}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="body_content">
                <mat-form-field appearance="legacy" class="full_width_form filter_form search">
                    <mat-label>
                        <ng-container [ngSwitch]="searchKey">
                            <ng-container *ngSwitchCase="'q'">{{ 'Everywhere' | translate}}</ng-container>
                            <ng-container *ngSwitchCase="'q_name'">{{ 'Chat title' | translate}}</ng-container>
                            <ng-container *ngSwitchCase="'q_text'">{{ 'Chat messages' | translate}}</ng-container>
                            <ng-container *ngSwitchCase="'task_custom_id'">{{ 'Card custom ID' | translate}}</ng-container>
                        </ng-container>
                    </mat-label>
                    <mat-icon class="icon_16" matPrefix>search</mat-icon>
                    <input class="search_inp" [formControl]="searchControl" matInput>
                    <mat-icon style="cursor: pointer;" (click)="$event.preventDefault(); $event.stopPropagation();" matSuffix [matMenuTriggerFor]="menuKey">more_vert</mat-icon>
                </mat-form-field>
                <mat-menu #menuKey="matMenu" class="sort_tablet new_sort_int">
                    <button mat-menu-item [ngClass]="{'active_status': searchKey == 'q'}" (click)="searchKey = 'q'; onFilterChats();">
                        <span>{{ 'Everywhere' | translate }}</span>
                    </button>
                    <button mat-menu-item [ngClass]="{'active_status': searchKey == 'q_name'}" (click)="searchKey = 'q_name'; onFilterChats();">
                        <span>{{ 'Chat title' | translate }}</span>
                    </button>
                    <button mat-menu-item [ngClass]="{'active_status': searchKey == 'q_text'}" (click)="searchKey = 'q_text'; onFilterChats();">
                        <span>{{ 'Chat messages' | translate }}</span>
                    </button>
                    <button mat-menu-item [ngClass]="{'active_status': searchKey == 'task_custom_id'}" (click)="searchKey = 'task_custom_id'; onFilterChats();">
                        <span>{{ 'Card custom ID' | translate }}</span>
                    </button>
                </mat-menu>
                <div class="frw_lite_chats" [ngClass]="{'centred': isLoad && chatsPage == 1}" [appDeviceClass]="'custom-scroll custom-scroll-t'"
                infinite-scroll
                [infiniteScrollDisabled]="isLoad"
                [scrollWindow]="false"
                [infiniteScrollUpDistance]="scrollUpDistance"
                [infiniteScrollThrottle]="throttle"
                (scrolled)="onDownChats($event)">
                    <ng-container *ngIf="isLoad && chatsPage == 1; else elseTemplateLoadedDone">
                        <mat-spinner></mat-spinner>
                    </ng-container>
                    <ng-template #elseTemplateLoadedDone>
                        <ng-container *ngFor="let item of chats">
                            <div class="chat"  
                            [ngClass]="{'todo_chat': [1,2,5].includes(item.status_id), 'done_chat': [3,4,6,97,98,99].includes(item.status_id), 'highlight_chat': item.is_read == '0', active: selectedChat  && selectedChat?.id == item.id}" 
                            (click)="selectChat(item)">
                                <div class="mini_chat_status" [ngClass]="{
                                    'first': item?.status_id == '1',
                                    'second': item?.status_id == '2',
                                    'third': item?.status_id == '3',
                                    'fours': item?.status_id == '4',
                                    'fives': item?.status_id == '5',
                                    'sixs': item?.status_id == '6',
                                    'nine': item?.status_id == '97',
                                    'seven': item?.status_id == '98',
                                    'eight': item?.status_id == '99'}"> 
                                </div>
                                <div class="chat_name text_one_line">{{item.name || 'Chat without title'}}</div>
                            </div>
                        </ng-container>
                        <mat-progress-bar mode="indeterminate" *ngIf="isLoad" class="mat_proggress_w8 job_proggress"></mat-progress-bar>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: 5px;">
    <div class="f_w_p_btns">
        <div class="d-f-c">
            <button class="ml-1 d-f-btn" (click)="onSubmit()" mat-raised-button cdkFocusInitial color="warn" *ngIf="filter.value.task_operation_id" [disabled]="isSubmit">
                <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
                <ng-container>{{"Forward to new Chat" | translate}}</ng-container>
            </button>
            <mat-form-field appearance="legacy" class="ml-1" *ngIf="filter.value.task_operation_id">
                <mat-label>{{ 'New Chat Title' | translate}}</mat-label>
                <input class="search_inp" [formControl]="newChatName" matInput>
            </mat-form-field>
        </div>
        <div class="d-f-c">
            <div class="box_wrp">
                <mat-checkbox color="primary" [(ngModel)]="isOpenAfter">{{"Open Chat After" | translate}}</mat-checkbox>
            </div>
            <button class="ml-1" mat-raised-button (click)="close()">
                {{ "Close" | translate }}
            </button>
            <button class="ml-1 d-f-btn" (click)="onSubmit()" mat-raised-button cdkFocusInitial color="primary" [disabled]="!selectedChat || isSubmit">
                <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
                <ng-container>{{"Forward" | translate}}</ng-container>
            </button>
        </div>
    </div>
</mat-dialog-actions>
